import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
// iso
import { Divider, Transfer, Row, Col } from 'antd';
import Button from '@isomorphic/shared/isomorphic/components/uielements/button';
import Form from '@isomorphic/shared/isomorphic/components/uielements/form';
import Modals from '@isomorphic/shared/isomorphic/components/Feedback/Modal';
import ModalStyle from './topbarUserSettingsModal.style';
import WithDirection from '../../settings/withDirection';
import { isMobile } from 'react-device-detect';
import DashboardAction from '../../redux/dashboard/actions';

const isoModal = ModalStyle(Modals);
const Modal = WithDirection(isoModal);

function DashboardSettings(props) {
  // eslint-disable-next-line
  const [mockDataHeader, setMockDataHeader] = useState([]);
  const [mockDataContent, setMockDataContent] = useState([]);
  const [targetKeysHeader, setTargetKeysHeader] = useState([]);
  const [targetKeysContent, setTargetKeysContent] = useState([]);

  useEffect(() => {
    getMock();
  }, []);

  // * set browser view
  var layout = {};
  layout['width'] = '800px';
  layout['style'] = { top: 10 };

  // * set mobile view
  if (isMobile) {
    layout['width'] = '100vw';
    layout['height'] = '100vh';
    layout['style'] = { top: 0 };
  }

  let CancelText = !props.cancelText ? 'Cancel' : props.cancelText;
  let SubmitText = !props.submitText ? 'Submit' : props.submitText;

  function handleChangeHeader(targetKeys) {
    setTargetKeysHeader(targetKeys);
  }

  function handleChangeContent(targetKeys) {
    setTargetKeysContent(targetKeys);
  }

  function handleSearch(dir, value) {
    console.log('search:', dir, value);
  }

  function getMock() {
    const mockDataHeader = [
      {
        key: '1',
        title: `Rejected (2x3)`,
        description: ``,
        chosen: 'true',
      },
      {
        key: '2',
        title: `Review (2x3)`,
        description: ``,
        chosen: 'true',
      },
      {
        key: '3',
        title: `Tasks (2x3)`,
        description: ``,
        chosen: 'true',
      },
      {
        key: '4',
        title: `MACH Activations (2x3)`,
        description: ``,
        chosen: 'true',
      },
      {
        key: '5',
        title: `New Activations (2x3)`,
        description: ``,
        chosen: 'true',
      },
    ];
    const mockDataContent = [
      {
        key: '1',
        title: `Users (2x3)`,
        description: ``,
        chosen: 'true',
      },
      {
        key: '2',
        title: `Services (2x3)`,
        description: ``,
        chosen: 'true',
      },
      {
        key: '3',
        title: `Services 2 (2x3)`,
        description: ``,
        chosen: 'true',
      },
    ];
    setMockDataHeader(mockDataHeader);
    setTargetKeysHeader(['1', '2', '3', '4', '5']);
    setMockDataContent(mockDataContent);
    setTargetKeysContent(['1', '2', '3']);
  }

  function handleSubmit(e) {
    props.onSubmit(targetKeysHeader, targetKeysContent);
  }

  return (
    <div id="modal-wrapper">
      <Modal
        {...layout}
        visible={props.visible}
        title={props.title}
        onCancel={props.onCancel}
        maskClosable={false}
        footer={[
          <Button key="back" size="large" onClick={props.onCancel}>
            {CancelText}
          </Button>,
          <Button
            key="submit"
            type="primary"
            size="large"
            loading={props.loading}
            onClick={handleSubmit}
          >
            {SubmitText}
          </Button>,
        ]}
      >
        <Form>
          <Row>
            <Divider orientation="left">Header Widgets</Divider>
            <Col xs={{ offset: 0 }} lg={{ offset: 3 }}>
              <Transfer
                dataSource={mockDataHeader}
                showSearch
                targetKeys={targetKeysHeader}
                onChange={handleChangeHeader}
                onSearch={handleSearch}
                render={item => item.title}
                listStyle={{
                  width: 300,
                  height: 300,
                }}
              />
            </Col>
            <Divider orientation="left">Content Widgets</Divider>
            <Col xs={{ offset: 0 }} lg={{ offset: 3 }}>
              <Transfer
                dataSource={mockDataContent}
                showSearch
                targetKeys={targetKeysContent}
                onChange={handleChangeContent}
                onSearch={handleSearch}
                listStyle={{
                  width: 300,
                  height: 300,
                }}
                render={item => item.title}
              />
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
}

export default connect(
  state => ({
    headerKeys: state.Dashboard.headerKeys,
    contentKeys: state.Dashboard.contentKeys,
  }),
  { ...DashboardAction }
)(DashboardSettings);
